module.exports = "/img/_/_/_/assets/images/creeper/battle/epic//6.jpg?6ff7268b73e013068ca26a1df346cc8c";